export const area_chart = () => (
  <path
    d="m21.75 5.25-9 8L9 9.5l-6.75 7.75M21.786 5.296v10.956a1 1 0 0 1-1 1H2.301"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
